export enum Category {
  SIGATURE_PLATTER = "PLAT SIGNATURE",
  BURGER = "BURGER",
  CORNDOG = "CORNDOG",
  CHICKEN = "GOLDEN CHICKEN",
  SIDE = "PETIT FAIM",
  COCKTAIL = "COCKTAIL",
  MATCHA_SMOOTHIE = "MATCHA & SMOOTHIE",
  DESSERT = "DESSERT",
}

export interface Product {
  id: string;
  name: string;
  price: string;
  category: Category;
  description: string;
  images: string[];
  isVisible: boolean;
}

export interface SideByCategory {
  [key: string]: {
    description: string;
    cold: string[];
    hot: string[];
  };
}
